import useAppTheme from 'hooks/shared/useAppTheme';
import AppCard from 'presentation/components/shared/card/AppCard';
import AppAreaChart from 'presentation/components/shared/chart/AppAreaChart';
import GridHeading from 'presentation/components/shared/grid/GridHeading';
import { Color } from 'presentation/theme/colorScheme';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { XAxis } from 'recharts';

interface Props {
  chartData: ChartPoint[];
}

const PeAssetChartView: FC<Props> = ({ chartData }) => {
  const { t } = useTranslation();

  const dateFormatter = (date: Date): string => date.getFullYear().toString();

  const theme = useAppTheme();

  return (
    <>
      <GridHeading>{t('peCompanyInvestmentsChart')}</GridHeading>
      <AppCard p="20px">
        <AppAreaChart
          chartData={chartData}
          tooltipFormatter={(value) => {
            return [`${value}m $`, t('raised') ?? ''];
          }}
          tooltipDateFormat="YYYY"
          xAxisDateFormat="YYYY"
          chartHeight={230}
          xAxis={
            <XAxis
              tickLine={false}
              dataKey="date"
              axisLine={{
                stroke: theme.colors[Color.Shade100],
                strokeWidth: 2,
              }}
              tickFormatter={(value: Date) => dateFormatter(value)}
            />
          }
          yAxisTickFormatter={(value) => {
            return `${value}m`;
          }}
          showXAxis={false}
          showYAxis={false}
          yAxisWidth={0}
        />
      </AppCard>
    </>
  );
};

export default PeAssetChartView;
